<div class="page-layout-container">
  <div class="page-header">
    <h1 class="title">Employee OffBoarding</h1>
    <p class="subtitle">
      Manage exit details, notice periods and assigned assets.
    </p>
  </div>

  <div *ngIf="successFlag" class="alert alert-success">
    Employee exit process updated successfully
  </div>

  <div *ngIf="errorFlag" class="alert alert-warning">
    {{ errorDescription }}
  </div>

  <form [formGroup]="empExitForm" class="exit-form">
    <div class="row align-items-center mb-4">
      <div class="col-md-6 col-lg-4 mb-3 mb-md-0">
        <app-emp-name
          [filterEmpName]="filterEmpName"
          (empName)="empNameSelected($event)"
        ></app-emp-name>
      </div>
    </div>

    <div class="form-grid">
      <mat-form-field appearance="outline" class="field-full">
        <mat-label>OnBoarding status</mat-label>
        <select matNativeControl required formControlName="onboardingStatus">
          <option value="active">Active</option>
          <option value="inActive">InActive</option>
          <option value="FreeLancer">FreeLancer</option>
        </select>
        <mat-error
          *ngIf="empExitForm.get('onboardingStatus')?.hasError('required')"
          >Required</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="outline" class="field-full">
        <mat-label>End of Contract </mat-label>
        <select matNativeControl required formControlName="endOfContract">
          <option value="" disabled hidden>Select End of Contract</option>
          <option value="1">Resignation</option>
          <option value="2">Termination</option>
        </select>
        <mat-error
          *ngIf="empExitForm.get('endOfContract')?.hasError('required')"
          >Required</mat-error
        >
      </mat-form-field>
      <mat-form-field appearance="outline" class="field-full">
        <mat-label>Notice Type </mat-label>
        <select matNativeControl required formControlName="noticeType">
          <option value="" disabled hidden>Select Notice Type</option>
          <option value="1">Registered Letter</option>
          <option value="2">Delivery of Letter</option>
        </select>
        <mat-error *ngIf="empExitForm.get('noticeType')?.hasError('required')"
          >Required</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="outline" class="field-full">
        <mat-label>Notice Start Date</mat-label>
        <input
          matInput
          [matDatepicker]="noticeStartDate"
          [matDatepickerFilter]="dateOfJoiningFilter"
          formControlName="noticeStartDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="noticeStartDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #noticeStartDate></mat-datepicker>
        <mat-error
          *ngIf="empExitForm.get('noticeStartDate')?.hasError('required')"
          >Required</mat-error
        >
      </mat-form-field>

      <mat-form-field appearance="outline" class="field-full">
        <mat-label>Notice Last Date </mat-label>
        <input
          matInput
          [matDatepicker]="noticeLastDate"
          [matDatepickerFilter]="dateOfJoiningFilter"
          formControlName="noticeLastDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="noticeLastDate"
        ></mat-datepicker-toggle>
        <mat-datepicker #noticeLastDate></mat-datepicker>
        <mat-error
          *ngIf="empExitForm.get('noticeLastDate')?.hasError('required')"
          >Required</mat-error
        >
      </mat-form-field>

      <div class="checkbox-group">
        <mat-checkbox #dav [checked]="davChecked" formControlName="dav"
          >DKV CheckList</mat-checkbox
        >
        <mat-checkbox #sim [checked]="simChecked" formControlName="sim"
          >SIM CheckList</mat-checkbox
        >
      </div>

      <mat-form-field appearance="outline" class="field-full comments-field">
        <mat-label>Comments</mat-label>
        <textarea
          matInput
          formControlName="comments"
          rows="3"
          placeholder="Additional notes"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="form-actions">
      <button
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        [disabled]="
          empExitForm.invalid ||
          !empExitForm.get('noticeType')?.value ||
          !empExitForm.get('endOfContract')?.value ||
          assetList.length > 0
        "
      >
        Confirm Exit
      </button>
    </div>
    <div *ngIf="assetList.length > 0" class="text-center mt-2">
      <small class="text-warning"
        >Cannot confirm exit while assigned assets exist. Please reclaim or
        reassign assets first.</small
      >
    </div>
  </form>

  <div *ngIf="assetList.length" class="asset-table">
    <h3>Assigned Assets</h3>
    <div class="table-responsive customScroll">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Asset ID</th>
            <th>Asset Type</th>
            <th>Description</th>
            <th>Assigned Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of assetList">
            <td>{{ row.assetId }}</td>
            <td>{{ row.assetType }}</td>
            <td *ngIf="row.assetType == 'Car'">
              {{ row.make }} - {{ row.model }}
            </td>
            <td
              *ngIf="
                row.assetType == 'Laptop' ||
                row.assetType == 'Monitor' ||
                row.assetType == 'Mobile' ||
                row.assetType == 'Other'
              "
            >
              {{ row.electronicModel }} - {{ row.electronicSerialNumber }}
            </td>
            <td *ngIf="row.assetType == 'SIM'">
              {{ row.mobileNumber }}
            </td>
            <td *ngIf="row.assetType == 'Fuel Card'">
              {{ row.fuelCard }}
            </td>
            <td>{{ row.empAssignedDate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-progress [loading$]="loading$"> </app-progress>
